import { render } from "./Banner.vue?vue&type=template&id=a077c682&lang=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
script.render = render

export default script